import React from 'react';
import { Helmet } from 'react-helmet-async';

const SITE_NAME = 'Restropilots';                        // ← change this
const BASE_URL  = 'https://www.restropilots.com';         // ← change this
const DEFAULT_IMAGE = `${BASE_URL}/og-image.jpg`;

const SEOMeta = ({ title, description, image, url, noIndex = false }) => {
  const fullTitle = title ? `${title} | ${SITE_NAME}` : `${SITE_NAME} – Discover the Best Restaurants Near You`;
  const metaDesc  = description || 'Find the best restaurants and cafés near you.';
  const ogImage   = image || DEFAULT_IMAGE;
  const pageUrl   = url   || window.location.href;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description"        content={metaDesc} />
      <link rel="canonical"           href={pageUrl} />
      {noIndex && <meta name="robots" content="noindex, nofollow" />}

      <meta property="og:title"       content={fullTitle} />
      <meta property="og:description" content={metaDesc} />
      <meta property="og:image"       content={ogImage} />
      <meta property="og:url"         content={pageUrl} />
      <meta property="og:type"        content="website" />
      <meta property="og:site_name"   content={SITE_NAME} />

      <meta name="twitter:card"        content="summary_large_image" />
      <meta name="twitter:title"       content={fullTitle} />
      <meta name="twitter:description" content={metaDesc} />
      <meta name="twitter:image"       content={ogImage} />
    </Helmet>
  );
};

export default SEOMeta;
